
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { RentalPoint } from '@/types/entities/rental-point';

// Re-export RentalPoint type for external use
export type { RentalPoint };

interface CurrentRentalPointState {
  currentRentalPoint: RentalPoint | null;
  currentUserId: string | null;
  setCurrentRentalPoint: (point: RentalPoint) => void;
  clearCurrentRentalPoint: () => void;
  setCurrentUser: (userId: string | null) => void;
}

export const useCurrentRentalPoint = create<CurrentRentalPointState>()(
  persist(
    (set, get) => ({
      currentRentalPoint: null,
      currentUserId: null,
      setCurrentRentalPoint: (point: RentalPoint) => set({ currentRentalPoint: point }),
      clearCurrentRentalPoint: () => set({ currentRentalPoint: null }),
      setCurrentUser: (userId: string | null) => {
        const state = get();
        // Если пользователь изменился, очищаем текущий пункт проката
        if (state.currentUserId !== userId) {
          set({ currentUserId: userId, currentRentalPoint: null });
        }
      },
    }),
    {
      name: 'current-rental-point',
    }
  )
);
